module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3itP8"))).then(() => parcelRequire('8rm4T'));